<template>
  <AppModal shown disableBackdrop noScroll>
    <AgreementView
      :terms="viewer"
      @agree="handleAgree"
      :class="$style.contents"
    />
  </AppModal>
</template>

<script setup lang="ts">
import AgreementView from './AgreementView.vue'
import AppModal from '@/components/atoms/AppModal.vue'

import { tryOnUnmounted, useScrollLock } from '@vueuse/core'

import {
  useAgreeTermsRequireAgreementMutation,
  type AgreementModalViewerFragment,
} from './AgreementModal.generated'

defineProps<{
  viewer: AgreementModalViewerFragment
}>()

const bodyEl = document.querySelector('body')
const lock = useScrollLock(bodyEl, true)

const { mutate } = useAgreeTermsRequireAgreementMutation({})

const handleAgree = async (
  agreed: AgreementModalViewerFragment['requiredAgreementTerms']
) => {
  const termRevisionIDs = agreed.map(({ id }) => id)
  await mutate({ termRevisionIDs })
}

tryOnUnmounted(() => {
  lock.value = false
})
</script>

<style lang="scss" module>
.contents {
  height: 100%;
  padding: 32px;
}
</style>
